import { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { LiveBadge } from 'src/svg/LiveBadge';

export enum GameCardBannerType {
  TOP = 'TOP',
  BONUS = 'BONUS',
  NEW = 'NEW',
  LIVE = 'LIVE'
}

interface GameCardBannerProps {
  type: GameCardBannerType;
}

export const GameCardBanner: FC<GameCardBannerProps> = ({ type }) => {
  const { t } = useTranslation();
  const getBadgeStyle = () => {
    switch (type) {
      case GameCardBannerType.TOP:
        return 'top-badge';
      case GameCardBannerType.BONUS:
        return 'bonus-badge';
      case GameCardBannerType.NEW:
        return 'new-badge';
      case GameCardBannerType.LIVE:
        return 'live-badge';
      default:
        return '';
    }
  };

  const getBadgeContent = () => {
    switch (type) {
      case GameCardBannerType.TOP:
        return 'categoryBadgeGame.top';
      case GameCardBannerType.BONUS:
        return 'categoryBadgeGame.bonus';
      case GameCardBannerType.NEW:
        return 'categoryBadgeGame.new';
      case GameCardBannerType.LIVE:
        return 'categoryBadgeGame.live';
      default:
        return '';
    }
  };

  return (
    <div className={classNames('badge', getBadgeStyle())}>
      {type === GameCardBannerType.LIVE && <LiveBadge />}
      {t(getBadgeContent())}
    </div>
  );
};
